import { Controller } from "@hotwired/stimulus";

// Auto-inserts the dashes in a YYYY-MM-DD birthday field as you type digits
// -- "19830701" becomes "1983-07-01" -- so typing it as one run of digits
// still works, without requiring the dashes to be typed by hand. Purely a
// display/typing convenience: the field's name/value shape submitted to
// the server is unchanged (still one plain "trav[N][birthday]" string in
// the same YYYY-MM-DD format Step2Controller#pax_birthday already expects,
// see _booking_form.html.erb's comment on that field).
export default class extends Controller {
  format(event) {
    const digits = event.target.value.replace(/\D/g, "").slice(0, 8);
    let formatted = digits.slice(0, 4);
    if (digits.length > 4) formatted += `-${digits.slice(4, 6)}`;
    if (digits.length > 6) formatted += `-${digits.slice(6, 8)}`;
    event.target.value = formatted;
  }
}
